import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "svg-nav_find_products",
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.93",
  height: "21.974",
  viewBox: "0 0 19.93 21.974"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(1 1.031)"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M22.43,16.941V8.975a1.991,1.991,0,0,0-1-1.723L14.461,3.27a1.993,1.993,0,0,0-1.992,0L5.5,7.253a1.991,1.991,0,0,0-1,1.723v7.966a1.991,1.991,0,0,0,1,1.723l6.973,3.983a1.993,1.993,0,0,0,1.992,0l6.973-3.983a1.991,1.991,0,0,0,1-1.723Z",
  transform: "translate(-4.5 -3.003)"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M4.9,10.44l8.671,5.5,8.671-5.5",
  transform: "translate(-4.611 -5.655)"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M18,28.973V18",
  transform: "translate(-9.035 -8.973)"
})], -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}